import {createAction} from "@reduxjs/toolkit";

/**
 * Event dispatched when authentication failed but prices should be unlocked.
 */
export const authFailedButUnlockPrices = createAction("auth/failedButUnlockPrices");
import {createAction} from "@reduxjs/toolkit";

/**
 * Event dispatched when authentication failed but prices should be unlocked.
 */
export const authFailedButUnlockPrices = createAction("auth/failedButUnlockPrices");
